export default "__VITE_ASSET__BleXWm3v__"